module.exports = __webpack_public_path__ + "img/InfinityStories-success.522cf0f7.png";